var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-2 pa-md-4 flex-grow-1 align-center justify-center d-flex flex-column"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }